/* eg-oregano-compounds — arrows for the ingredient rail.
   The rail is a native scroll-snap strip, so swiping works on its own; the
   arrows move it one card at a time and dim at either end. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.egocInit === 'true') return;
    root.dataset.egocInit = 'true';

    var rail = root.querySelector('[data-egoc-rail]');
    var prev = root.querySelector('[data-egoc-prev]');
    var next = root.querySelector('[data-egoc-next]');
    if (!rail) return;

    function step() {
      var card = rail.querySelector('[data-egoc-card]');
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max - 1;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-egoc]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
